import { createTheme, responsiveFontSizes } from "@material-ui/core";

const theme = responsiveFontSizes(createTheme());

export default theme;
